import { getCiraServiceEndpoint } from '../../config/runtimeConfig';

const ApiBaseUrl = getCiraServiceEndpoint();

export const ApiUrls = {
    base: ApiBaseUrl,
    issuer: ApiBaseUrl + '/issuer',
    user: ApiBaseUrl + '/user',
    assignment: ApiBaseUrl + '/assignment',
    company: ApiBaseUrl + '/company',
    credential: ApiBaseUrl + '/credential',
};
